// Variant B ("Product-led") styles. Everything is scoped under .vb so nothing leaks into other variants.
export const vbCss = `
.vb { --vb-paper2: #FBFBFD; --vb-rule: #E4E3F0; }
.vb .vb-mono { font-family: 'Geist Mono', ui-monospace, monospace; }
.vb .vb-label { font-family: 'Geist Mono', ui-monospace, monospace; font-size: 11.5px; letter-spacing: .12em; text-transform: uppercase; color: var(--bm-muted); }
.vb .vb-rule { border-color: var(--vb-rule); }
.vb .vb-dots { background-image: radial-gradient(circle at 1px 1px, rgba(36,30,97,.13) 1px, transparent 1.3px); background-size: 18px 18px; }
.vb .vb-two { color: var(--bm-muted); }
.vb .vb-h2 { font-weight: 800; font-size: clamp(30px, 3.6vw, 48px); line-height: 1.06; letter-spacing: -0.035em; color: var(--bm-indigo); }
.vb .vb-hero-h1 { font-weight: 800; font-size: clamp(40px, 4.6vw, 66px); line-height: 1.0; letter-spacing: -0.042em; color: var(--bm-indigo); }

/* Nav breakpoint: scoped media queries (desktop links from 1024px) */
.vb .vb-navlinks { display: none; }
@media (min-width: 1024px) {
  .vb .vb-navlinks { display: flex; }
  .vb .vb-burger, .vb .vb-mmenu { display: none !important; }
}

/* Hero: stacked below 1100px, split (copy 45 / visual 55) from 1100px */
.vb .vb-hero-grid { display: grid; grid-template-columns: minmax(0, 1fr); gap: 40px; }
.vb .vb-hero-panel { position: relative; }
.vb .vb-h1-stack { display: grid; }
.vb .vb-h1-stack > * { grid-area: 1 / 1; }
.vb .vb-hero-grid > * { min-width: 0; }
.vb .vb-pill-short { display: none; }
@media (max-width: 479px) { .vb .vb-pill-long { display: none; } .vb .vb-pill-short { display: inline; } }
@media (min-width: 1100px) {
  .vb .vb-hero-wrap { padding-top: clamp(32px, 6vh, 72px); padding-bottom: clamp(40px, 7vh, 80px); }
  .vb .vb-hero-grid { grid-template-columns: minmax(0, 43fr) minmax(0, 57fr); gap: 48px; align-items: center; }
  .vb .vb-hero-grid .vb-hero-h1 { font-size: clamp(42px, 3.5vw, 52px); line-height: 1.04; }
}

/* Email capture */
.vb .vb-capture { display: flex; align-items: center; gap: 6px; padding: 6px; border-radius: 999px; background: #fff; box-shadow: inset 0 0 0 1.5px var(--vb-rule), 0 10px 30px -18px rgba(24,19,67,.35); transition: box-shadow .18s var(--bm-ease); max-width: 500px; }
.vb .vb-capture:focus-within { box-shadow: inset 0 0 0 1.5px var(--bm-indigo), 0 10px 30px -18px rgba(24,19,67,.35); }
.vb .vb-capture input { flex: 1; min-width: 0; height: 48px; padding: 0 18px; border: 0; outline: none; background: transparent; font: inherit; font-size: 16.5px; color: var(--bm-ink); }
.vb .vb-capture input::placeholder { color: #8E8CB0; }
.vb .vb-capture .btn { flex: none; }
.vb .vb-capture input:focus-visible { outline: none; }
.vb .on-dark .vb-capture { background: rgba(255,255,255,.06); box-shadow: inset 0 0 0 1.5px rgba(255,255,255,.22); }
.vb .on-dark .vb-capture:focus-within { box-shadow: inset 0 0 0 1.5px var(--bm-lime); }
.vb .on-dark .vb-capture input { color: #fff; }
.vb .on-dark .vb-capture input::placeholder { color: rgba(255,255,255,.55); }
@media (max-width: 520px) {
  .vb .vb-capture { flex-direction: column; align-items: stretch; border-radius: 20px; padding: 6px; }
  .vb .vb-capture .btn { width: 100%; }
}

/* Proof ticker */
.vb .vb-ticker { overflow: hidden; -webkit-mask-image: linear-gradient(90deg, transparent, #000 6%, #000 94%, transparent); mask-image: linear-gradient(90deg, transparent, #000 6%, #000 94%, transparent); }
.vb .vb-ticker-track { display: flex; width: max-content; animation: vb-marquee 48s linear infinite; }
.vb .vb-ticker:hover .vb-ticker-track { animation-play-state: paused; }
@keyframes vb-marquee { to { transform: translateX(-50%); } }

/* Hero visual */
.vb .vb-hv { position: relative; }
.vb .vb-hv * { box-sizing: border-box; }
.vb .vb-cut { transition: opacity .22s var(--bm-ease), transform .32s var(--bm-ease); }
.vb .vb-scanline { position: absolute; left: 10%; right: 10%; height: 2px; background: #CFF710; box-shadow: 0 0 12px 2px rgba(207,247,16,.55); animation: vb-scan 1.6s var(--bm-ease) infinite alternate; }
@keyframes vb-scan { from { top: 18%; } to { top: 80%; } }
.vb .vb-row-new { animation: vb-row-in .5s var(--bm-ease) both; }
@keyframes vb-row-in { from { transform: translateY(-14px); opacity: 0; } to { transform: none; opacity: 1; } }
.vb .vb-row-flash { animation: vb-flash 2.6s var(--bm-ease) .35s both; }
@keyframes vb-flash { 0% { background: #F1FBD0; } 70% { background: #F4FBE1; } 100% { background: #FAFDF2; } }
.vb .vb-toast { animation: vb-toast .42s var(--bm-ease) both; }
@keyframes vb-toast { from { transform: translateY(10px); opacity: 0; } to { transform: none; opacity: 1; } }
.vb .vb-tick { transition: background-color .2s var(--bm-ease), box-shadow .2s var(--bm-ease); }
.vb .vb-sig path { stroke-dasharray: 260; stroke-dashoffset: 260; }
.vb .vb-sig.is-on path { animation: vb-draw .9s var(--bm-ease) forwards; }
@keyframes vb-draw { to { stroke-dashoffset: 0; } }
.vb .vb-link-path { stroke-dasharray: 5 6; animation: vb-dash 1s linear infinite; }
@keyframes vb-dash { to { stroke-dashoffset: -22; } }
.vb .vb-pulse { animation: vb-pulse 1.6s var(--bm-ease) infinite; }
@keyframes vb-pulse { 0% { box-shadow: 0 0 0 0 rgba(63,174,108,.45); } 100% { box-shadow: 0 0 0 10px rgba(63,174,108,0); } }

/* Before / after */
.vb .vb-frag { position: absolute; will-change: transform, opacity; }
.vb .vb-frag-drift { animation: vb-drift var(--d, 4.2s) ease-in-out infinite alternate; }
@keyframes vb-drift { from { translate: 0 -3px; } to { translate: 0 3px; } }

/* Tabs */
.vb .vb-tab { position: relative; text-align: left; width: 100%; padding: 20px 0 22px; border-top: 1px solid var(--vb-rule); cursor: pointer; }
.vb .vb-tab-bar { position: absolute; left: 0; top: -1px; height: 2px; background: var(--bm-indigo); transform-origin: left center; }
.vb .vb-tab-body { display: grid; grid-template-rows: 0fr; transition: grid-template-rows .3s var(--bm-ease); }
.vb .vb-tab[aria-selected="true"] .vb-tab-body { grid-template-rows: 1fr; }
.vb .vb-tab-body > * { overflow: hidden; min-height: 0; }

/* Cards / links */
.vb .vb-card { background: #fff; border: 1px solid var(--vb-rule); border-radius: 18px; }
.vb .vb-lift { transition: transform .22s var(--bm-ease), box-shadow .22s var(--bm-ease), border-color .22s var(--bm-ease); }
.vb .vb-lift:hover { transform: translateY(-2px); box-shadow: 0 22px 40px -28px rgba(24,19,67,.4); border-color: #CFCDE4; }
.vb .vb-arrow-link { display: inline-flex; align-items: center; gap: 6px; font-weight: 600; color: var(--bm-indigo); }
.vb .vb-arrow-link svg { transition: transform .18s var(--bm-ease); }
.vb .vb-arrow-link:hover svg { transform: translateX(3px); }
.vb .vb-ext::after { content: '\\2197'; margin-left: 4px; font-family: 'Geist Mono', ui-monospace, monospace; }

/* FAQ */
.vb .vb-faq summary { list-style: none; cursor: pointer; }
.vb .vb-faq summary::-webkit-details-marker { display: none; }
.vb .vb-faq .vb-plus { transition: transform .2s var(--bm-ease); }
.vb .vb-faq details[open] .vb-plus { transform: rotate(45deg); }

@media (prefers-reduced-motion: reduce) {
  .vb .vb-ticker-track { animation: none; flex-wrap: wrap; width: auto; }
  .vb .vb-scanline { display: none; }
  .vb .vb-frag-drift { animation: none; }
}
`;
